import * as Tooltip from "@radix-ui/react-tooltip";
import { forwardRef, type ButtonHTMLAttributes, type ReactNode } from "react";
import { useMedia } from "../lib/useMedia";

type Props = ButtonHTMLAttributes<HTMLButtonElement> & { label: string; children: ReactNode; size?: "md" | "sm"; tip?: boolean };

/** Круглая кнопка без подписи: доступное имя обязательно, подсказка — для мыши и клавиатуры. */
export const IconButton = forwardRef<HTMLButtonElement, Props>(function IconButton(
  { label, children, size = "md", tip = true, className = "", ...rest },
  ref,
) {
  // На сенсорных экранах подсказок нет: они мешают первому касанию и перехватывают Escape.
  const hover = useMedia("(hover: hover) and (pointer: fine)");
  const btn = (
    <button
      ref={ref}
      type="button"
      aria-label={label}
      {...rest}
      className={`pressable inline-grid flex-none place-items-center rounded-control text-ink-2 hover:bg-hover hover:text-ink [&_svg]:size-5 ${
        size === "sm" ? "size-10 pointer-coarse:size-11" : "size-11"
      } ${className}`}
    >
      {children}
    </button>
  );
  if (!tip || !hover) return btn;
  return (
    <Tooltip.Root>
      <Tooltip.Trigger asChild>{btn}</Tooltip.Trigger>
      <Tooltip.Portal>
        <Tooltip.Content
          sideOffset={6}
          className="z-[90] rounded-lg bg-ink px-2.5 py-1.5 text-xs font-medium text-bg shadow-floating data-[state=delayed-open]:animate-[tip_160ms_var(--ease-out)]"
        >
          {label}
        </Tooltip.Content>
      </Tooltip.Portal>
    </Tooltip.Root>
  );
});
